<div class="modal-header">
  <h5 class="modal-title"><i class="fal fa-sticky-note"></i> {{ data ? 'Edit' : 'New' }} Note</h5>
  <button (click)="close()" type="button" class="close" aria-label="Close">
    <i class="fas fa-times"></i>
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="form" [formEditablePermission]="form">
    <div class="row">
      <!-- Title -->
      <div class="col-md-12">
        <mat-form-field class="mat-block mat-txt-area" appearance="outline">
          <textarea
            matInput
            #notes
            maxlength="500"
            rows="8"
            formControlName="note"
            placeholder="Type your notes here.."
          ></textarea>
          <mat-hint align="end">{{ form.get('note').value?.length || 0 }}/500</mat-hint>
        </mat-form-field>
      </div>
    </div>
  </form>
</div>
<div class="modal-footer">
  <button
    (click)="close()"
    type="button"
    [disabled]="1 | isReadonlyRole"
    class="btn btn-outline btn-default-outline text-uppercase"
  >
    <i class="fal fa-times"></i> cancel
  </button>
  <button *ngIf="data" (click)="delete()" type="button" class="btn btn-danger text-uppercase">
    <i class="fal fa-trash-alt"></i> delete
  </button>
  <button
    (click)="save(form)"
    [disabled]="1 | isReadonlyRole"
    type="button"
    class="btn btn-success text-uppercase create-btn"
  >
    <i class="fal fa-save"></i> save
  </button>
</div>
